/**
 * harness/pinyin.js
 * T-Cron-2026-10-23 14:00 — 改进清单 #15「搜索:拼音」
 *
 * 为什么需要:
 *   看板是**中文内容库**。用户想找《设计心理学》,必须切输入法打五个汉字;
 *   而筛选面板的搜索框是纯文本匹配,打 "sjxl" **一篇都搜不出来**。
 *   根目录老仓库(components/SearchOverlay.jsx)有一份手写 BOOK_PINYIN 表,
 *   Vite 迁移时这段能力整体丢失 —— 老用户已经习惯的输入方式又失效了。
 *
 * 为什么是「手写表」而不是引入拼音库:
 *   pypinyin 压缩后仍有 ~200 KB,而本书籍集合是**封闭且已知的 110 本**。
 *   手写表 ≈ 3 KB,零依赖,零运行时开销。
 *   表由 `scripts/_gen_pinyin.py` 在**构建期**离线生成(需要 pypinyin),
 *   生成的字面量提交进仓库 ⇒ 运行时**完全不依赖 pypinyin**。
 *
 * 匹配语义:
 *   查询是 ASCII 字母/数字 ⇒ 与拼音首字母做 **子串 + 前缀** 匹配。
 *   "sjxl" / "sjxlx" / "sheji" 都能命中《设计心理学》。
 *   查询含 CJK ⇒ 走原有的中文字面量匹配(见 contentService.searchPosts)。
 *
 * 维护点:新增书籍后跑一次 `python3 scripts/_gen_pinyin.py` 重新生成。
 */
const BOOK_PINYIN = {
  '21世纪资本论': '21sjzbl',
  'GEB': 'geb',
  '一九八四': 'yjbs',
  '一课经济学': 'ykjjx',
  '万历十五年': 'wlswn',
  '三体': 'st',
  '乌合之众': 'whzz',
  '乡土中国': 'xtzg',
  '人口峭壁': 'rkqb',
  '人类简史': 'rljs',
  '从0到1': 'c0d1',
  '从优秀到卓越': 'cyxdzy',
  '代码2.0': 'dm20',
  '伟大的博弈': 'wddby',
  '你当像鸟飞往你的山': 'ndxnfwnds',
  '信息简史': 'xxjs',
  '倦怠社会': 'jdsh',
  '债务危机': 'zwwj',
  '公正': 'gz',
  '刻意练习': 'kylx',
  '反脆弱': 'fcr',
  '只有偏执狂才能生存': 'zypzkcnsc',
  '叫魂': 'jh',
  '吾国教育病理': 'wgjybl',
  '周期': 'zq',
  '商业的本质': 'sydbz',
  '国家为什么会失败': 'gjwsmhsb',
  '国富论': 'gfl',
  '坚毅': 'jy',
  '基业长青': 'jyzq',
  '增长的极限': 'zzdjx',
  '大停滞': 'dtz',
  '大国的兴衰': 'dgdxs',
  '大而不倒': 'debd',
  '大败局': 'dbj',
  '失控': 'sk',
  '奇点临近': 'qdlj',
  '娱乐至死': 'ylzs',
  '寂静的春天': 'jjdct',
  '小的是美好的': 'xdsmhd',
  '工作消费主义和新穷人': 'gzxfzyhxqr',
  '平台革命': 'ptgm',
  '影响力': 'yxl',
  '心流': 'xl',
  '思考快与慢': 'skkym',
  '我们为什么生病': 'wmwsmsb',
  '我们最后的发明': 'wmzhdfm',
  '技术垄断': 'jsld',
  '故事': 'gs',
  '数字化生存': 'szhsc',
  '文明的冲突': 'wmdct',
  '旅行的艺术': 'lxdys',
  '景观社会': 'jgsh',
  '智能时代': 'znsd',
  '月亮与六便士': 'ylylbs',
  '有闲阶级论': 'yxjjl',
  '未来简史': 'wljs',
  '杂食者的两难': 'zszdln',
  '枪炮病菌与钢铁': 'qpbjygt',
  '活着': 'hz',
  '浅薄': 'qb',
  '浪潮之巅': 'lczd',
  '漫步华尔街': 'mbhej',
  '激荡三十年': 'jdssn',
  '灰犀牛': 'hxn',
  '爱弥儿': 'ame',
  '牛奶可乐经济学': 'nnkljjx',
  '狂热分子': 'krfz',
  '理解媒介': 'ljmj',
  '瓦尔登湖': 'wedh',
  '生命3.0': 'sm30',
  '生育制度': 'syzd',
  '白板': 'bb',
  '百岁人生': 'bsrs',
  '皇帝新脑': 'hdxn',
  '看得见的与看不见的': 'kdjdykbjd',
  '硅谷之谜': 'ggzm',
  '科技想要什么': 'kjxysm',
  '稀缺': 'xq',
  '穷查理宝典': 'qclbd',
  '童年的消逝': 'tndxs',
  '第三次浪潮': 'dsclc',
  '简爱': 'ja',
  '算法霸权': 'sfbq',
  '终身成长': 'zscz',
  '置身事内': 'zssn',
  '美国陷阱': 'mgxj',
  '聪明的投资者': 'cmdtzz',
  '能源重塑世界': 'nyzssj',
  '自卑与超越': 'zbycy',
  '自私的基因': 'zsdjy',
  '舆论': 'yl',
  '艺术的故事': 'ysdgs',
  '被讨厌的勇气': 'btydyq',
  '认知天性': 'rztx',
  '设计心理学': 'sjxlx',
  '语言本能': 'yybn',
  '说谎者的扑克牌': 'shzdpkp',
  '贫穷的本质': 'pqdbz',
  '跨越鸿沟': 'kyhg',
  '路西法效应': 'lxfxy',
  '身份的焦虑': 'sfdjl',
  '道德情操论': 'ddqcl',
  '金融的本质': 'jrdbz',
  '金融的逻辑': 'jrdlj',
  '钓愚': 'dy',
  '门口的野蛮人': 'mkdymr',
  '非理性繁荣': 'flxfr',
  '黑天鹅': 'hte',
  '黑客与画家': 'hkyhj',
};

if (typeof window !== 'undefined') {
  window.BOOK_PINYIN = BOOK_PINYIN;
}

/**
 * 取一本书的拼音首字母(未知书名返回空串)。
 * @param {string} book
 * @returns {string}
 */
function getBookPinyin(book) {
  if (!book) return '';
  return BOOK_PINYIN[book] || '';
}

/**
 * 判断一个纯 ASCII 查询是否可以走拼音匹配通道。
 * 必须至少含一个字母(纯数字查询交给字面量匹配,避免误伤)。
 * @param {string} q 已小写并 trim 的查询
 * @returns {boolean}
 */
function isPinyinQuery(q) {
  return /^[a-z0-9]+$/.test(q) && /[a-z]/.test(q);
}

export { BOOK_PINYIN, getBookPinyin, isPinyinQuery };
export default { BOOK_PINYIN, getBookPinyin, isPinyinQuery };
